export enum DocumentDefTypeEnum {
  DOCUMENT_MANAGEMENT = 'DOCUMENT_MANAGEMENT',
  COMPANY = 'COMPANY',
}
